import { useSlip } from "@/contexts/SlipContext";
import { Plus, Check } from "lucide-react";
import { toast } from "sonner";

/**
 * AddToSlipButton — small icon button to add an upcoming fixture to "Mkeka Wangu".
 * The pick must include enough data for the parlay backend to call multi-source prediction.
 */
const AddToSlipButton = ({ fixture, idx, className = "", size = "sm" }) => {
    const { has, addPick, removePick } = useSlip();
    const id = fixture.event_id || fixture.id || `${fixture.home_team}-${fixture.away_team}`;
    const inSlip = has(id);

    const onToggle = (e) => {
        e?.stopPropagation();
        e?.preventDefault();
        if (inSlip) {
            removePick(id);
            return;
        }
        addPick({
            id,
            event_id: fixture.event_id || fixture.id,
            home_team: fixture.home_team,
            away_team: fixture.away_team,
            home_logo: fixture.home_logo,
            away_logo: fixture.away_logo,
            home_abbr: fixture.home_abbr,
            away_abbr: fixture.away_abbr,
            league_id: fixture.competition_id || fixture.league_id,
            league_name_sw: fixture.competition_name_sw || fixture.competition_name || "",
            league_flag: fixture.flag || "🌐",
            kickoff_iso: fixture.kickoff_iso || fixture.date,
            choice: "HOME",
        });
        toast.success(`${fixture.home_team} vs ${fixture.away_team} imeongezwa kwenye Mkeka`);
    };

    const sizeClasses = size === "lg"
        ? "h-9 px-3 text-xs"
        : "h-7 px-2 text-[11px]";

    return (
        <button
            onClick={onToggle}
            className={`inline-flex items-center gap-1 rounded font-bold uppercase tracking-wider transition-colors ${sizeClasses} ${
                inSlip
                    ? "bg-emerald-500 text-white hover:bg-emerald-600"
                    : "bg-electric/15 text-electric hover:bg-electric hover:text-white"
            } ${className}`}
            data-testid={`add-to-slip-${idx ?? id}`}
            aria-label={inSlip ? "Imeshaongezwa" : "Ongeza kwenye mkeka"}
        >
            {inSlip ? <Check className="h-3 w-3" /> : <Plus className="h-3 w-3" />}
            <span>{inSlip ? "Mkekani" : "Ongeza"}</span>
        </button>
    );
};

export default AddToSlipButton;
